export const segment_endpoint = {
    segment:'segments',
    segmentDetails:'segments',
    filter:'segments/filters',
    list:'segments/list',
    validate:'segments/validate',
    permission:'segments/pa-list',
    changeStatus:'segments/admin-action',
    contentPool:'segments/content-pool'
}
